var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUntucked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_4567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6052 -22.0665C23.4379 -24.3436 26.7326 -25.6931 32.8808 -28.5015L39.4095 -25.0966L47.4688 -28.314L61.8382 -23.1286C68.8978 -19.5987 66.7736 -4.44846 68.3668 10.0146C69.2925 18.4175 68.4581 24.0968 67.4297 35.8169L67.0548 42.4081C64.3704 40.5086 62.7906 40.5698 59.9327 41.2835C61.5257 32.8806 60.4815 27.9318 59.058 19.1672C58.8249 10.5638 58.7231 5.72337 57.1525 -2.10563C54.5902 8.0442 54.2738 13.9817 54.8409 24.8212C51.3422 25.6959 45.8782 25.951 39.472 25.977C36.1274 26.1939 32.5168 25.8959 23.0722 24.6338C23.8843 14.3879 27.5391 9.98335 23.9067 -1.10602C23.1271 3.48825 22.0412 6.23483 21.0104 12.7635C20.7293 23.1344 19.3638 25.1594 18.1053 34.255C18.5741 36.8451 19.1974 38.5771 19.9797 41.1585C19.1049 40.3776 13.201 40.5963 12.2327 42.4081L11.5142 35.3171C10.3991 26.335 11.2754 18.2224 12.4524 7.327L12.4826 7.04701C14.7317 -1.13726 14.6068 -16.8498 18.6052 -22.0665Z",
    fill: "white",
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M65.6034 33.4436C64.6663 33.4177 61.8049 30.7009 61.605 30.3511L61.7924 30.9446L62.6358 31.7255L64.0103 33.1L62.2297 32.9126L64.7912 33.4436L67.4152 34.0059L65.6034 33.4436Z",
    fill: "black",
    fillOpacity: 0.45,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.6553 26.2278C14.4423 26.6048 15.9045 27.7164 15.9981 28.0083C14.9421 27.2733 14.4458 26.9963 13.8739 26.9462C13.31 27.1271 12.5908 27.8956 12.4354 28.1145C12.4115 28.1617 12.4007 28.1812 12.4058 28.1645C12.4086 28.1551 12.4188 28.1379 12.4354 28.1145C12.5735 27.8422 13.1503 26.6505 13.6553 26.2278Z",
    fill: "black",
    fillOpacity: 0.45,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.6552 13.2332C13.6861 13.2762 12.9746 13.8104 12.7805 13.9204C13.0095 13.6774 13.1905 13.5601 13.1866 13.2332C13.0032 13.0859 12.912 13.1716 12.7493 13.3269C12.9483 12.9717 13.0627 12.7774 13.499 12.7959C15.6115 13.2701 16.7609 13.6398 18.7157 14.5452C17.0982 14.0625 13.5702 13.1151 13.6552 13.2332Z",
    fill: "black",
    fillOpacity: 0.45,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5033 26.0705C37.535 10.7641 39.2844 -1.60603 38.2847 -24.0659",
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4177 34.5985C15.4633 33.7676 13.9173 33.7982 11.5454 35.5668C11.7641 37.8472 12.2239 42.5568 12.2326 42.5016C12.4299 41.259 17.5118 40.0963 19.9796 41.1584C19.2556 38.661 18.8813 37.2603 18.4177 34.5985Z",
    fill: "white",
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1825 35.7858C63.024 33.941 64.6108 33.8604 67.3984 35.5983L67.0548 42.4394C64.6174 40.7594 63.0646 40.3627 59.8389 41.3148C60.1238 39.3704 60.2061 38.1139 60.1825 35.7858Z",
    fill: "white",
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.75,
    cx: 40.5653,
    cy: 7.23445,
    r: 0.437327,
    fill: "black",
    fillOpacity: 0.6,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.75,
    cx: 40.3153,
    cy: 16.6055,
    r: 0.437327,
    fill: "black",
    fillOpacity: 0.6,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M63.6499 9.92066C62.7232 10.9411 60.801 13.0819 60.5262 13.4818C60.3926 13.749 60.1606 14.2383 60.0293 14.5879C59.9646 14.8571 59.9238 15.0075 59.9326 14.9187C59.9398 14.8469 59.9764 14.7288 60.0293 14.5879C60.1467 14.0995 60.3428 13.2201 60.4637 12.6696L63.0876 9.702L59.3704 8.70239L65.1806 9.51457L63.6499 9.92066Z",
    fill: "black",
    fillOpacity: 0.3,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.6364 10.2959C19.331 10.7822 20.0882 11.2407 21.0417 11.5142L20.6981 11.2643L20.3545 11.0144L19.8859 10.4521C20.2614 10.2742 20.5902 10.2928 21.0417 10.2959C20.2736 10.0863 19.7496 10.1039 18.855 10.0772C16.8455 9.18176 15.8876 8.39795 14.0757 7.17212C15.7164 8.56588 16.6608 9.31608 18.6364 10.2959Z",
    fill: "black",
    fillOpacity: 0.3,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1454 51.9569C20.8093 41.3087 20.9257 35.3687 22.9169 24.9426",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5308 51.9569C37.0771 46.6461 37.646 43.7555 39.3023 38.6711C40.4733 43.6941 40.874 46.5955 41.0737 51.9569",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6882 51.0714C56.1677 40.5332 55.8799 34.7328 54.8025 24.5",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5881 34.2429C24.0624 31.1327 24.3661 30.0159 26 25.5",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 25.7144L38.8442 39.0002C41.3677 33.9228 41.6847 31.3454 41.4552 25.7145",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0001 25C51.9736 29.1001 53.2954 30.9486 55.6883 33.3571",
    stroke: "#999999",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_4567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 59,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUntucked);
export default __webpack_public_path__ + "static/media/untucked.426831c13323204b56b5cfe227995f3e.svg";
export { ForwardRef as ReactComponent };